import { Status } from "components/presentation/Status";
import { useGetConfigSports, useGetScheduleStartList } from "helpers/commonCodes";
import { getLongPhaseRSC } from "helpers/rsc";
import { useGetPath, useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useLocation } from "react-router-dom";

export function usePreparePayLoad() {
  //isH2H section
  const { mirs_competition, mirs_rsc, mirs_discipline, mirs_language } = useUrlFriendlyToParameters()
  const dataConfigSport = useGetConfigSports({ mirs_competition, mirs_discipline });
  const noH2hPhases = dataConfigSport?.noH2hPhases;
  const isH2H = (Array.isArray(noH2hPhases) && noH2hPhases.find(p => (new RegExp(p)).test(getLongPhaseRSC(mirs_rsc))) ? false : dataConfigSport?.isH2H)

  //Status section
  const scheduleSL = useGetScheduleStartList()
  const scheduleItem = scheduleSL?.find(schedule => schedule?.code === mirs_rsc)
  const statusCode = Status({ typeToPrint: 'schedule', scheduleStatus: scheduleItem?.status?.code, resultStatus: scheduleItem?.result?.status?.code, onlyCodeForEvent: true })

  //Pathname section
  const location = useLocation();

  //UrlData section
  let obj = useGetPath()

  return ({
    isH2H: isH2H,
    statusCode: statusCode,
    resultStatusCode: scheduleItem?.result?.status?.code,
    pathname: location.pathname,
    urlData: obj(mirs_language).url

  })

}

